// frontend/modules/loans/index.ts
import { ModuleConfig } from '@/core/module';
import { loanRoutes } from './routes';
import { useLoanApplicationStore } from './stores/loan-application-store';
import { PendingGuarantorRequests } from './components/dashboard';

// Export components and hooks for external use
export { PendingGuarantorRequests } from './components/dashboard';
export { useGuarantorActions } from './hooks/useGuarantorActions';

export const LoanModule: ModuleConfig = {
    name: 'loans',
    routes: loanRoutes,
    stores: {
        loanApplication: useLoanApplicationStore
    },
    dashboardComponents: {
        PendingGuarantorRequests
    },
    initialize: () => {
        console.log('Loan module initialized');
    }
};